/* eslint-disable @next/next/no-img-element */
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import Paper from '@base/Paper/Paper';
import H2 from '@base/H2/H2';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Banner from '@cont/TalkToUnacademy/Banner';
import useTopology from '@api/hooks/topology/useTopology';
import AllAboutExam from '@cont/NewPreSubscribed/AllAboutExam';
import useWindowSize from '@hooks/useWindowSize';
import { getIsSubscribed } from '@selectors/subscription';
import useTTUStore from '@stores/ttu';
import { getTTUIsGoalEnabled } from '@stores/selectors/ttuSelectors';
import PropTypes from 'prop-types';
import Typography from 'aquilla/core/atoms/Typography';
import breadcrumbs, { goBack } from '@utils/breadcrumbs';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import EntireFeed from './EntireFeed';

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-bottom: ${Spacings.SPACING_8B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_10B};
  background: var(--color-base-1);
  img {
    height: 64px;
    width: 64px;
  }
  ${mediaQuery.uptoMobile} {
    background: var(--color-base-0);
    padding: ${Spacings.SPACING_6B}${Spacings.SPACING_0B} ${Spacings.SPACING_0B};
    box-shadow: none;
    flex-direction: column;
    align-items: flex-start;
    img {
      display: none;
    }
  }
`;

const StyH2 = styled(H2)`
  margin-top: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H3};
    line-height: ${Spacings.SPACING_7B};
  }
`;

const WrapperTTU = styled.div`
  grid-column: span 18;
`;

const Description = styled(Typography)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_3B};
`;

const FreeLiveClasses = ({ goal, pageMetaInfo }) => {
  const router = useRouter();
  const { goalUID } = router.query;

  const { topology: goalTopology } = useTopology(goalUID);
  const { isMobile } = useWindowSize();

  const isGoalEnabled = useTTUStore(getTTUIsGoalEnabled);
  const isSubscribed = useSelector(getIsSubscribed);
  const { name: goalName } = goalTopology;

  return (
    <>
      <StyledPaper
        gridColumn="span 18"
        padding={`${Spacings.SPACING_10B} ${Spacings.SPACING_12B}`}
      >
        <BreadCrumbs
          onBackClick={goBack}
          tags={breadcrumbs.getFreeLiveClassesTags(goal)}
          useBackClick
        />
        <StyH2 as="h1">{pageMetaInfo?.title || goalName}</StyH2>
        {pageMetaInfo?.description && (
          <Description variant="p2">{pageMetaInfo.description}</Description>
        )}
      </StyledPaper>
      <EntireFeed sectionMetaInfo={pageMetaInfo?.CUSTOM_FEED} />
      {isGoalEnabled && !isSubscribed && !isMobile && (
        <WrapperTTU>
          <Banner goalDetails={goal} />
        </WrapperTTU>
      )}
      <AllAboutExam width="848px" />
    </>
  );
};

export default FreeLiveClasses;

FreeLiveClasses.propTypes = {
  pageMetaInfo: PropTypes.objectOf(PropTypes.any)
};

FreeLiveClasses.defaultProps = {
  pageMetaInfo: {}
};
